export default "__VITE_ASSET__C7Tdr$oz__"